import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import styles from "./Volunteer.module.scss";

const StepThree = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const handleFinish = () => {
    navigate("/"); // Redirect to the homepage
  };

  return (
      <div className={styles.StepOneContainer}>
        <h1>{t("app.volunteers.thankYouForApplying")}</h1>
        <p>{t("app.volunteers.stepThree.p1")}</p>
        <br />
        <p>{t("app.volunteers.stepThree.p2")}</p>
        <div className={styles.ButtonAlignment}>
        <Button type="primary" onClick={handleFinish} className={styles.ButtonStyle}>
          {t("app.volunteers.stepThree.finish")}
        </Button>
        </div>
      </div>
  );
};

export default StepThree;
